var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarStories({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2196_1433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8L4 16C4 16.55 4.45 17 5 17L18 17C18.55 17 19 16.55 19 16L19 8C19 7.45 18.55 7 18 7L5 7C4.45 7 4 7.45 4 8Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20C6 20.55 6.45 21 7 21L16 21C16.55 21 17 20.55 17 20C17 19.45 16.55 19 16 19L7 19C6.45 19 6 19.45 6 20Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6 4.55 6.45 5 7 5L16 5C16.55 5 17 4.55 17 4C17 3.45 16.55 3 16 3L7 3C6.45 3 6 3.45 6 4Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2196_1433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 24) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarStories);
export default __webpack_public_path__ + "static/media/similar_stories.76ac711a39cd47dbb5716266afc52254.svg";
export { ForwardRef as ReactComponent };